export const asstmgtassetitems = [
  {
    id: 1,
    s_no: 1,
    filter_unique_id: "FLT-001",
    filter_type: "HEPA",
    filter_manufacturer: "AirClean Co.",
    installation_date: "2023-01-15",
    location_type: "Cleanroom",
    filter_dimensions: "610x610x305 mm",
    micron_rating: "0.3 µm",
    cleaning_frequency_days: 30,
    cleaning_frequency_allowance_days: 5,
    max_allowed_cleanings: 10,
    last_cleaning_date: "2024-12-01",
    valid_operational_life_days: 365,
    ahu_unique_id: "AHU-101",
    current_status: "Active",
    availability_status: "In Use",
    label: "AHU-01/FLT",
  },
  {
    id: 2,
    s_no: 2,
    filter_unique_id: "FLT-002",
    filter_type: "Pre-filter",
    filter_manufacturer: "PureAir Ltd.",
    installation_date: "2023-03-10",
    location_type: "HVAC",
    filter_dimensions: "500x500x100 mm",
    micron_rating: "5 µm",
    cleaning_frequency_days: 60,
    cleaning_frequency_allowance_days: 10,
    max_allowed_cleanings: 5,
    last_cleaning_date: "2025-05-15",
    valid_operational_life_days: 180,
    ahu_unique_id: "AHU-102",
    current_status: "Cleaning",
    availability_status: "Unavailable",
    label: "AHU-01/FLT-001",
  },
  {
    id: 3,
    s_no: 3,
    filter_unique_id: "FLT-003",
    filter_type: "Bag filter",
    filter_manufacturer: "FilterTech",
    installation_date: "2022-11-20",
    location_type: "Warehouse",
    filter_dimensions: "800x400x200 mm",
    micron_rating: "10 µm",
    cleaning_frequency_days: 90,
    cleaning_frequency_allowance_days: 7,
    max_allowed_cleanings: 6,
    last_cleaning_date: "2025-04-20",
    valid_operational_life_days: 540,
    ahu_unique_id: "AHU-103",
    current_status: "Active",
    availability_status: "Spare",
    label: "AHU-01/FLT-001",
  },
  {
    id: 4,
    s_no: 4,
    filter_unique_id: "FLT-004",
    filter_type: "HEPA",
    filter_manufacturer: "CleanZone",
    installation_date: "2023-07-05",
    location_type: "Production Area",
    filter_dimensions: "600x600x292 mm",
    micron_rating: "0.5 µm",
    cleaning_frequency_days: 45,
    cleaning_frequency_allowance_days: 3,
    max_allowed_cleanings: 8,
    last_cleaning_date: "2025-05-02",
    valid_operational_life_days: 400,
    ahu_unique_id: "AHU-104",
    current_status: "Storage",
    availability_status: "Spare",
    label: "AHU-01/FLT-001",
  },
  {
    id: 5,
    s_no: 5,
    filter_unique_id: "FLT-005",
    filter_type: "Pre-filter",
    filter_manufacturer: "FiltraMax",
    installation_date: "2023-02-12",
    location_type: "HVAC",
    filter_dimensions: "610x305x152 mm",
    micron_rating: "3 µm",
    cleaning_frequency_days: 20,
    cleaning_frequency_allowance_days: 2,
    max_allowed_cleanings: 15,
    last_cleaning_date: "2025-04-10",
    valid_operational_life_days: 300,
    ahu_unique_id: "AHU-105",
    current_status: "Active",
    availability_status: "In Use",
    label: "AHU-01/FLT-001",
  },
  {
    id: 6,
    s_no: 6,
    filter_unique_id: "FLT-006",
    filter_type: "Bag filter",
    filter_manufacturer: "FilterTech",
    installation_date: "2022-09-30",
    location_type: "Cleanroom",
    filter_dimensions: "700x500x250 mm",
    micron_rating: "8 µm",
    cleaning_frequency_days: 60,
    cleaning_frequency_allowance_days: 6,
    max_allowed_cleanings: 7,
    last_cleaning_date: "2025-03-01",
    valid_operational_life_days: 365,
    ahu_unique_id: "AHU-106",
    current_status: "Storage",
    availability_status: "Spare",
    label: "AHU-01/FLT-001",
  },
  {
    id: 7,
    s_no: 7,
    filter_unique_id: "FLT-007",
    filter_type: "HEPA",
    filter_manufacturer: "AirClean Co.",
    installation_date: "2023-08-12",
    location_type: "Production Area",
    filter_dimensions: "610x610x292 mm",
    micron_rating: "0.3 µm",
    cleaning_frequency_days: 40,
    cleaning_frequency_allowance_days: 4,
    max_allowed_cleanings: 10,
    last_cleaning_date: "2025-05-10",
    valid_operational_life_days: 365,
    ahu_unique_id: "AHU-107",
    current_status: "Cleaning",
    availability_status: "Unavailable",
    label: "AHU-01/FLT-001",
  },
  {
    id: 8,
    s_no: 8,
    filter_unique_id: "FLT-008",
    filter_type: "Pre-filter",
    filter_manufacturer: "PureAir Ltd.",
    installation_date: "2023-06-18",
    location_type: "HVAC",
    filter_dimensions: "500x500x100 mm",
    micron_rating: "5 µm",
    cleaning_frequency_days: 30,
    cleaning_frequency_allowance_days: 3,
    max_allowed_cleanings: 12,
    last_cleaning_date: "2025-04-30",
    valid_operational_life_days: 240,
    ahu_unique_id: "AHU-108",
    current_status: "Active",
    availability_status: "In Use",
    label: "AHU-01/FLT-001",
  },
  {
    id: 9,
    s_no: 9,
    filter_unique_id: "FLT-009",
    filter_type: "Bag filter",
    filter_manufacturer: "CleanZone",
    installation_date: "2023-01-01",
    location_type: "Warehouse",
    filter_dimensions: "800x400x200 mm",
    micron_rating: "10 µm",
    cleaning_frequency_days: 50,
    cleaning_frequency_allowance_days: 5,
    max_allowed_cleanings: 9,
    last_cleaning_date: "2025-03-20",
    valid_operational_life_days: 450,
    ahu_unique_id: "AHU-109",
    current_status: "Storage",
    availability_status: "Spare",
    label: "AHU-01/FLT-001",
  },
  {
    id: 10,
    s_no: 10,
    filter_unique_id: "FLT-010",
    filter_type: "HEPA",
    filter_manufacturer: "FiltraMax",
    installation_date: "2023-10-05",
    location_type: "Cleanroom",
    filter_dimensions: "610x610x305 mm",
    micron_rating: "0.2 µm",
    cleaning_frequency_days: 35,
    cleaning_frequency_allowance_days: 5,
    max_allowed_cleanings: 11,
    last_cleaning_date: "2025-04-25",
    valid_operational_life_days: 400,
    ahu_unique_id: "AHU-110",
    current_status: "Active",
    availability_status: "In Use",
    label: "AHU-01/FLT-001",
  },
  {
    id: 11,
    s_no: 11,
    filter_unique_id: "FLT-011",
    filter_type: "Bag filter",
    filter_manufacturer: "AirClean Co.",
    installation_date: "2022-12-22",
    location_type: "HVAC",
    filter_dimensions: "700x500x250 mm",
    micron_rating: "15 µm",
    cleaning_frequency_days: 70,
    cleaning_frequency_allowance_days: 7,
    max_allowed_cleanings: 8,
    last_cleaning_date: "2025-04-01",
    valid_operational_life_days: 500,
    ahu_unique_id: "AHU-111",
    current_status: "Storage",
    availability_status: "Spare",
    label: "AHU-01/FLT-001",
  },
  {
    id: 12,
    s_no: 12,
    filter_unique_id: "FLT-012",
    filter_type: "Pre-filter",
    filter_manufacturer: "FilterTech",
    installation_date: "2023-05-15",
    location_type: "Production Area",
    filter_dimensions: "600x400x150 mm",
    micron_rating: "4 µm",
    cleaning_frequency_days: 25,
    cleaning_frequency_allowance_days: 3,
    max_allowed_cleanings: 14,
    last_cleaning_date: "2025-05-01",
    valid_operational_life_days: 350,
    ahu_unique_id: "AHU-112",
    current_status: "Cleaning",
    availability_status: "Unavailable",
  },
];
